/**
 * BioHerbs dcoded-llp landing page interactions
 * No section.id coupling — uses data-dcoded-llp-* attributes only.
 */
(function () {
  'use strict';

  var PURCHASE_EVENT = 'dcoded-llp:purchase-change';
  var inited = new WeakSet();

  function markInited(el) {
    if (!el || inited.has(el)) return false;
    inited.add(el);
    return true;
  }

  /* ---------- Drag scroll ---------- */
  function enableDragScroll(scroller) {
    if (!scroller || scroller.dataset.dcodedLlpDragBound === 'true') return;
    scroller.dataset.dcodedLlpDragBound = 'true';

    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    var moved = false;

    scroller.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      if (e.target.closest('a, button, input, label, [data-dcoded-llp-no-drag]')) return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      scrollLeft = scroller.scrollLeft;
      scroller.classList.add('is-dragging');
      try {
        scroller.setPointerCapture(e.pointerId);
      } catch (err) {}
    });

    scroller.addEventListener('pointermove', function (e) {
      if (!isDown || e.pointerType === 'touch') return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      scroller.scrollLeft = scrollLeft - dx;
    });

    function endDrag(e) {
      if (!isDown) return;
      isDown = false;
      scroller.classList.remove('is-dragging');
      if (moved && e && e.type === 'pointerup') {
        scroller.dataset.dcodedLlpSuppressClick = 'true';
        setTimeout(function () {
          delete scroller.dataset.dcodedLlpSuppressClick;
        }, 80);
      }
    }

    scroller.addEventListener('pointerup', endDrag);
    scroller.addEventListener('pointercancel', endDrag);
    scroller.addEventListener('pointerleave', function () {
      if (isDown) endDrag();
    });

    scroller.addEventListener(
      'click',
      function (e) {
        if (scroller.dataset.dcodedLlpSuppressClick === 'true') {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }

  /* ---------- Reviews ---------- */
  function initReviews(root) {
    if (!root || !markInited(root)) return;
    var track = root.querySelector('[data-dcoded-llp-reviews-track]');
    if (track) enableDragScroll(track);
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    if (!root || !markInited(root)) return;
    var track = root.querySelector('[data-dcoded-llp-gallery-track]');
    var dotsWrap = root.querySelector('[data-dcoded-llp-gallery-dots]');
    if (!track || !dotsWrap) return;

    var slides = track.querySelectorAll('[data-dcoded-llp-gallery-slide]');
    var dots = dotsWrap.querySelectorAll('[data-dcoded-llp-gallery-dot]');
    var timer;

    function setDot(i) {
      dots.forEach(function (d, k) {
        d.classList.toggle('is-on', k === i);
        d.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-index'), 10) || 0;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        setDot(i);
      });
    });

    track.addEventListener(
      'scroll',
      function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (!track.clientWidth) return;
          setDot(Math.max(0, Math.round(track.scrollLeft / track.clientWidth)));
        }, 60);
      },
      { passive: true }
    );

    enableDragScroll(track);
    setDot(0);
  }

  /* ---------- Offer / tiers ---------- */
  function publishPurchase(detail) {
    document.dispatchEvent(new CustomEvent(PURCHASE_EVENT, { detail: detail || {} }));
  }

  function showOfferError(message) {
    var el = document.querySelector('[data-dcoded-llp-offer-error]');
    if (!el) return;
    if (message) {
      el.textContent = message;
      el.hidden = false;
    } else {
      el.textContent = '';
      el.hidden = true;
    }
  }

  function readTierData(tier) {
    return {
      id: tier.getAttribute('data-tier-id') || '',
      pouchPrice: tier.getAttribute('data-pouch-price') || '',
      stickyNote: tier.getAttribute('data-sticky-note') || '',
      stickyCta: tier.getAttribute('data-sticky-cta') || '',
      reassure: tier.getAttribute('data-reassure') || '',
      quantity: parseInt(tier.getAttribute('data-quantity'), 10) || 1,
      mode: tier.getAttribute('data-mode') || 'one_time',
      sellingPlan: tier.getAttribute('data-selling-plan') || '',
      tierIndex: parseInt(tier.getAttribute('data-tier-index'), 10) || 0,
      productHandle: tier.getAttribute('data-product-handle') || '',
    };
  }

  function setSellingPlanOnForm(form, sellingPlan) {
    var planInput = form.querySelector('[data-dcoded-llp-selling-plan]');
    if (!planInput) return;
    if (sellingPlan) {
      planInput.value = String(sellingPlan);
      planInput.setAttribute('name', 'selling_plan');
    } else {
      planInput.value = '';
      planInput.removeAttribute('name');
    }
  }

  function applyTierToForm(root, data) {
    var form = root.querySelector('[data-dcoded-llp-product-form]') || root;
    var qtyInput = form.querySelector('[data-dcoded-llp-quantity-input]');
    if (qtyInput) qtyInput.value = String(data.quantity || 1);
    setSellingPlanOnForm(form, data.sellingPlan || '');

    var purchase = root.matches('[data-dcoded-llp-purchase]')
      ? root
      : root.querySelector('[data-dcoded-llp-purchase]');
    if (purchase) {
      purchase.setAttribute('data-selected-tier', data.id || '');
      purchase.setAttribute('data-pouch-price', data.pouchPrice || '');
      purchase.setAttribute('data-sticky-note', data.stickyNote || '');
      purchase.setAttribute('data-sticky-cta', data.stickyCta || '');
      purchase.setAttribute('data-reassure', data.reassure || '');
      purchase.setAttribute('data-quantity', String(data.quantity || 1));
      purchase.setAttribute('data-mode', data.mode || 'one_time');
      purchase.setAttribute('data-selling-plan', data.sellingPlan || '');
    }
  }

  function findMoneyAll(text) {
    var matches = String(text || '').match(/(£|\$|€)\s?[\d,.]+/g) || [];
    return matches.map(function (m) {
      return m.replace(/\s+/g, '');
    });
  }

  function moneyValue(str) {
    return parseFloat(String(str || '').replace(/[^\d.]/g, '')) || 0;
  }

  /** Kaching marks compare-at as bar-full-price (struck through), not "compare". */
  var COMPARE_PRICE_SELECTOR = [
    's',
    'del',
    '[style*="line-through"]',
    '[class*="compare"]',
    '[class*="Compare"]',
    '[class*="full-price"]',
    '[class*="FullPrice"]',
    '[class*="was-price"]',
    '[class*="WasPrice"]',
    '[class*="original-price"]',
    '[class*="strike"]',
    '.kaching-bundles__bar-full-price',
  ].join(', ');

  function hasLineThrough(el) {
    var cur = el;
    for (var i = 0; i < 6 && cur && cur.nodeType === 1; i++) {
      if (cur.matches && cur.matches(COMPARE_PRICE_SELECTOR)) return true;
      try {
        var style = window.getComputedStyle(cur);
        var deco = (style && (style.textDecorationLine || style.textDecoration)) || '';
        if (String(deco).indexOf('line-through') !== -1) return true;
      } catch (err) {}
      cur = cur.parentElement;
    }
    return false;
  }

  /** Collect money strings from live DOM, skipping compare-at / struck prices. */
  function findSalePrices(root) {
    if (!root) return [];
    var found = [];
    var seen = {};
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var matches = String(node.textContent || '').match(/(£|\$|€)\s?[\d,.]+/g);
      if (!matches) continue;
      if (hasLineThrough(node.parentElement)) continue;
      matches.forEach(function (m) {
        var price = m.replace(/\s+/g, '');
        if (!seen[price]) {
          seen[price] = true;
          found.push(price);
        }
      });
    }
    return found;
  }

  function pickLargest(prices) {
    if (!prices || !prices.length) return '';
    return prices.slice().sort(function (a, b) {
      return moneyValue(b) - moneyValue(a);
    })[0];
  }

  function pickFullPackPrice(mount) {
    if (!mount) return '';

    // 1) Selected delivery-frequency card (Subscribe / One-time) — discounted total.
    var freqCard = null;
    var freqLen = Infinity;
    mount.querySelectorAll('label, [role="radio"], button, li, div, section').forEach(function (el) {
      var text = el.textContent || '';
      if (!/subscribe|one[\s-]?time/i.test(text)) return;
      if (text.length > 600) return;
      var checked =
        el.matches('[aria-checked="true"], [aria-pressed="true"], .selected, .is-selected, [class*="selected"]') ||
        !!el.querySelector('input:checked, [aria-checked="true"]');
      if (!checked) return;
      // Prefer the tightest matching card (avoids oversized wrappers).
      if (text.length < freqLen) {
        freqLen = text.length;
        freqCard = el;
      }
    });

    if (freqCard) {
      // Strip Kaching compare-at nodes, then read remaining money.
      var freqClone = freqCard.cloneNode(true);
      freqClone.querySelectorAll(COMPARE_PRICE_SELECTOR).forEach(function (node) {
        node.remove();
      });
      var freqPrices = findMoneyAll(freqClone.textContent || '');
      // Live-DOM pass also drops computed line-through (clone can't see CSS).
      var liveSale = findSalePrices(freqCard);
      if (liveSale.length) freqPrices = liveSale;

      if (freqPrices.length === 1) return freqPrices[0];
      if (freqPrices.length === 2) {
        // Frequency cards show discounted total + compare-at; take the lower (final) price.
        return moneyValue(freqPrices[0]) <= moneyValue(freqPrices[1])
          ? freqPrices[0]
          : freqPrices[1];
      }
      if (freqPrices.length > 2) return pickLargest(freqPrices);
    }

    // 2) Fallback: largest non-compare price in the whole mount.
    return pickLargest(findSalePrices(mount));
  }

  function isElSelected(el) {
    if (!el) return false;
    return (
      el.matches(
        '[aria-checked="true"], [aria-pressed="true"], [aria-selected="true"], .selected, .is-selected, [class*="selected"]'
      ) || !!el.querySelector('input:checked, [aria-checked="true"], [aria-selected="true"]')
    );
  }

  function readKachingPackQty(mount, formQty) {
    var found = 0;
    if (mount) {
      mount.querySelectorAll('label, [role="radio"], button, li, div').forEach(function (el) {
        var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (text.length > 220) return;
        var buyMatch = text.match(/buy\s+(\d+)\s+packs?/i);
        if (!buyMatch) return;
        if (!isElSelected(el) && !(el.querySelector && el.querySelector('input:checked'))) return;
        found = parseInt(buyMatch[1], 10) || found;
      });

      if (!found) {
        var summary = (mount.textContent || '').match(/(\d+)\s+packs?\s+repeats/i);
        if (summary) found = parseInt(summary[1], 10) || 0;
      }
    }
    return found || formQty || 1;
  }

  function readKachingFrequencyMonths(mount) {
    if (!mount) return 0;

    var months = 0;
    mount.querySelectorAll('select').forEach(function (select) {
      if (months) return;
      var opt = select.options && select.options[select.selectedIndex];
      var label = ((opt && opt.textContent) || select.value || '').replace(/\s+/g, ' ');
      if (!/month/i.test(label)) return;
      var m = label.match(/(\d+)\s*months?/i);
      if (m) months = parseInt(m[1], 10) || 0;
    });
    if (months) return months;

    var best = '';
    var bestLen = Infinity;
    mount.querySelectorAll('label, [role="radio"], button, li, div, section').forEach(function (el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/subscribe/i.test(text) || !/every\s+\d+\s+months?/i.test(text)) return;
      if (text.length > 600) return;
      if (!isElSelected(el)) return;
      if (text.length < bestLen) {
        bestLen = text.length;
        best = text;
      }
    });

    var match = best.match(/every\s+(\d+)\s+months?/i);
    if (!match) match = (mount.textContent || '').match(/repeats?\s+every\s+(\d+)\s+months?/i);
    return match ? parseInt(match[1], 10) || 0 : 0;
  }

  function readKachingIsSubscribe(mount, sellingPlan) {
    if (!mount) return !!sellingPlan;

    var best = '';
    var bestLen = Infinity;
    mount.querySelectorAll('label, [role="radio"], button, li, div, section').forEach(function (el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/subscribe|one[\s-]?time/i.test(text)) return;
      if (text.length > 600) return;
      if (!isElSelected(el)) return;
      if (text.length < bestLen) {
        bestLen = text.length;
        best = text;
      }
    });

    if (best) {
      if (/one[\s-]?time/i.test(best) && !/repeats?\s+every/i.test(best)) return false;
      if (/subscribe/i.test(best)) return true;
    }
    return !!sellingPlan;
  }

  function formatStickyPackNote(qty, isSubscribe, months) {
    var packLabel = String(qty || 1) + '-PACK';
    if (!isSubscribe) return packLabel + ' • ONE-TIME';
    if (months) return packLabel + ' • EVERY ' + months + ' MONTHS';
    return packLabel + ' • SUBSCRIPTION';
  }

  function syncStickyFromKachingForm(root) {
    var form = root.querySelector('[data-dcoded-llp-product-form]');
    if (!form) return;

    var formQty = parseInt((form.querySelector('[name="quantity"]') || {}).value, 10) || 1;
    var planEl = form.querySelector('[name="selling_plan"]');
    var sellingPlan = planEl && planEl.value ? planEl.value : '';
    var mount = root.querySelector('[data-dcoded-llp-kaching-mount]');
    var qty = readKachingPackQty(mount, formQty);
    var isSubscribe = readKachingIsSubscribe(mount, sellingPlan);
    var months = isSubscribe ? readKachingFrequencyMonths(mount) : 0;

    // Full pack / delivery total — not the "per pack" deal-bar price.
    var price = pickFullPackPrice(mount);

    var detail = {
      quantity: qty,
      sellingPlan: sellingPlan,
      mode: isSubscribe ? 'subscribe' : 'one_time',
      pouchPrice: price || '',
      stickyUnit: '',
      stickyNote: formatStickyPackNote(qty, isSubscribe, months),
      stickyCta: isSubscribe
        ? 'Buy Now' + (price ? ' · ' + price : '')
        : 'Add to cart' + (price ? ' · ' + price : ''),
      reassure: isSubscribe
        ? 'Subscription · cancel anytime · free UK delivery'
        : 'One-time · free UK delivery',
    };

    publishPurchase(detail);
  }

  function matchesPreferredFrequency(text, preferredFreq, preferredId) {
    var t = String(text || '');
    if (preferredId && (t === String(preferredId) || t.indexOf(String(preferredId)) !== -1)) {
      return true;
    }
    if (preferredFreq && new RegExp(String(preferredFreq).replace(/\s+/g, '\\s*'), 'i').test(t)) {
      return true;
    }
    return /6\s*months?/i.test(t);
  }

  /**
   * Custom <kaching-bundle> mounts on non-PDP pages can ignore the app default
   * and select the first frequency in the dropdown (3 months). Align to 6 months once.
   */
  function applyPreferredKachingFrequency(root) {
    var mount = root.querySelector('[data-dcoded-llp-kaching-mount]');
    var form = root.querySelector('[data-dcoded-llp-product-form]');
    if (!mount || mount.getAttribute('data-dcoded-llp-plan-pref-applied') === 'true') return false;

    var preferredId =
      mount.getAttribute('data-preferred-selling-plan') ||
      (form &&
        form.querySelector('[data-preferred-selling-plan]') &&
        form.querySelector('[data-preferred-selling-plan]').getAttribute('data-preferred-selling-plan')) ||
      '';
    var preferredFreq = mount.getAttribute('data-preferred-frequency') || '6 months';
    var changed = false;

    mount.querySelectorAll('select').forEach(function (select) {
      var options = Array.prototype.slice.call(select.options || []);
      if (options.length < 2) return;
      var looksLikeFreq = options.some(function (opt) {
        return /month/i.test(opt.textContent || '') || /month/i.test(opt.value || '');
      });
      if (!looksLikeFreq) return;

      var target = null;
      options.forEach(function (opt) {
        if (target) return;
        if (matchesPreferredFrequency(opt.textContent, preferredFreq, preferredId)) target = opt;
        else if (matchesPreferredFrequency(opt.value, preferredFreq, preferredId)) target = opt;
      });
      if (!target) return;

      if (String(select.value) !== String(target.value)) {
        select.value = target.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        changed = true;
      }
      mount.setAttribute('data-dcoded-llp-plan-pref-applied', 'true');
    });

    if (mount.getAttribute('data-dcoded-llp-plan-pref-applied') === 'true') return changed;

    // Custom dropdown / radio UIs — click the 6-month choice once if 3 months is active.
    var optionNodes = mount.querySelectorAll(
      '[role="option"], [role="radio"], label, li, button, option, .kaching-bundles__option, [class*="option"]'
    );
    var sixNode = null;
    var sixSelected = false;
    var threeSelected = false;
    optionNodes.forEach(function (el) {
      var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/repeats?\s+every\s+\d+\s+months?/i.test(text) && !/every\s+\d+\s+months?/i.test(text)) {
        return;
      }
      if (text.length > 80) return;
      var selected =
        el.matches('[aria-selected="true"], [aria-checked="true"], .selected, .is-selected, [class*="selected"]') ||
        !!(el.closest && el.closest('[aria-selected="true"], [aria-checked="true"], .selected, .is-selected'));
      if (/3\s*months?/i.test(text) && selected) threeSelected = true;
      if (matchesPreferredFrequency(text, preferredFreq, preferredId)) {
        if (!sixNode) sixNode = el;
        if (selected) sixSelected = true;
      }
    });

    if (sixSelected) {
      mount.setAttribute('data-dcoded-llp-plan-pref-applied', 'true');
      return false;
    }

    if (sixNode && threeSelected) {
      try {
        sixNode.click();
        changed = true;
      } catch (err) {}
      mount.setAttribute('data-dcoded-llp-plan-pref-applied', 'true');
      return changed;
    }

    if (preferredId && form) {
      var planInputs = form.querySelectorAll('[name="selling_plan"]');
      var currentText = mount.textContent || '';
      planInputs.forEach(function (input) {
        if (!input.value || String(input.value) === String(preferredId)) return;
        if (/3\s*months?/i.test(currentText) && /6\s*months?/i.test(currentText)) {
          input.value = String(preferredId);
          input.dispatchEvent(new Event('change', { bubbles: true }));
          changed = true;
          mount.setAttribute('data-dcoded-llp-plan-pref-applied', 'true');
        }
      });
    }

    return changed;
  }

  function bindKachingStickySync(root) {
    var mount = root.querySelector('[data-dcoded-llp-kaching-mount]');
    var form = root.querySelector('[data-dcoded-llp-product-form]');
    if (!mount || !form) return;

    var schedule = function () {
      window.setTimeout(function () {
        applyPreferredKachingFrequency(root);
        syncStickyFromKachingForm(root);
      }, 50);
    };

    mount.addEventListener('click', schedule);
    mount.addEventListener('change', schedule);
    form.addEventListener('change', schedule);

    ['deal-bar-selected', 'variant-selected', 'variants-changed'].forEach(function (evt) {
      mount.addEventListener(evt, schedule);
      document.addEventListener(evt, schedule);
    });

    if (typeof MutationObserver !== 'undefined') {
      var obs = new MutationObserver(schedule);
      obs.observe(mount, { childList: true, subtree: true, attributes: true });
      setTimeout(function () {
        obs.disconnect();
      }, 15000);
    }

    // Retry while Kaching hydrates its frequency dropdown.
    var tries = 0;
    var boot = window.setInterval(function () {
      tries += 1;
      applyPreferredKachingFrequency(root);
      syncStickyFromKachingForm(root);
      if (mount.getAttribute('data-dcoded-llp-plan-pref-applied') === 'true' || tries >= 40) {
        window.clearInterval(boot);
      }
    }, 250);

    schedule();
  }

  function initOffer(root) {
    if (!root || !markInited(root)) return;

    var kachingVisible = root.getAttribute('data-kaching-visible') === 'true';
    var tiers = root.querySelectorAll('[data-dcoded-llp-tier]');

    if (!kachingVisible && tiers.length) {
      function selectTier(tier) {
        tiers.forEach(function (t) {
          var on = t === tier;
          t.classList.toggle('is-selected', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var data = readTierData(tier);
        applyTierToForm(root, data);
        publishPurchase(data);
      }

      tiers.forEach(function (tier) {
        tier.addEventListener('click', function () {
          selectTier(tier);
        });
        tier.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectTier(tier);
          }
        });
      });

      var selected = root.querySelector('[data-dcoded-llp-tier].is-selected') || tiers[0];
      if (selected) selectTier(selected);
    }

    // When Kaching UI is the selector, follow its form state for sticky copy.
    if (kachingVisible) {
      bindKachingStickySync(root);
    }
  }

  /* ---------- Sticky CTA ---------- */
  function updateStickyUI(sticky, detail) {
    if (!sticky || !detail) return;
    var priceEl = sticky.querySelector('[data-dcoded-llp-sticky-price]');
    var unitEl = sticky.querySelector('[data-dcoded-llp-sticky-unit]');
    var noteEl = sticky.querySelector('[data-dcoded-llp-sticky-note]');
    var reassureEl = sticky.querySelector('[data-dcoded-llp-sticky-reassure]');
    var ctaEl = sticky.querySelector('[data-dcoded-llp-sticky-cta]');

    if (priceEl && detail.pouchPrice) priceEl.textContent = detail.pouchPrice;
    if (unitEl && typeof detail.stickyUnit === 'string') unitEl.textContent = detail.stickyUnit;
    if (noteEl && detail.stickyNote) noteEl.textContent = detail.stickyNote;
    if (reassureEl && detail.reassure) reassureEl.textContent = detail.reassure;
    if (ctaEl && detail.stickyCta) ctaEl.textContent = detail.stickyCta;
  }

  function scrollToBuy(e) {
    var buy = document.querySelector('#dcoded-llp-buy');
    if (!buy) return false;
    if (e) e.preventDefault();
    buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }

  function initBuyScrollLinks(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-dcoded-llp-scroll-buy], a[href="#dcoded-llp-buy"]').forEach(function (link) {
      if (link.dataset.dcodedLlpScrollBound === 'true') return;
      link.dataset.dcodedLlpScrollBound = 'true';
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href') || '';
        if (href === '#dcoded-llp-buy' || link.hasAttribute('data-dcoded-llp-scroll-buy')) {
          scrollToBuy(e);
        }
      });
    });
  }

  function checkoutUrl() {
    var root =
      (window.routes && window.routes.root) ||
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + 'checkout';
  }

  function cartAddUrl() {
    var url =
      (window.routes && window.routes.cart_add_url) ||
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add'
        : '/cart/add');
    if (url.indexOf('.js') === -1) url += '.js';
    return url;
  }

  function resetStickyCtas() {
    document.querySelectorAll('[data-dcoded-llp-sticky-cta]').forEach(function (cta) {
      cta.removeAttribute('aria-disabled');
      cta.removeAttribute('disabled');
      cta.classList.remove('is-loading');
    });
  }

  function prepareFormData(form) {
    // Drop empty selling_plan so one-time purchases don't fail.
    var plans = form.querySelectorAll('[name="selling_plan"]');
    plans.forEach(function (input) {
      if (!input.value) input.removeAttribute('name');
    });

    var ourPlan = form.querySelector('[data-dcoded-llp-selling-plan]');
    if (ourPlan && !ourPlan.value) ourPlan.removeAttribute('name');

    return new FormData(form);
  }

  function addOfferToCart(cta) {
    var form = document.querySelector('[data-dcoded-llp-product-form]');
    if (!form) {
      var buy = document.querySelector('#dcoded-llp-buy');
      if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
      else if (cta && cta.getAttribute('data-fallback-href')) {
        window.location.href = cta.getAttribute('data-fallback-href');
      }
      return Promise.resolve(false);
    }

    showOfferError('');
    resetStickyCtas();

    var formData = prepareFormData(form);
    var variantId = formData.get('id');
    if (!variantId) {
      showOfferError('Product variant is missing. Assign the Berberine product in the Offer section.');
      return Promise.resolve(false);
    }

    if (cta) {
      cta.setAttribute('aria-disabled', 'true');
      cta.classList.add('is-loading');
    }

    // Use FormData (not JSON) so Kaching-injected fields/properties are preserved.
    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
      credentials: 'same-origin',
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, status: response.status, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || (result.data && result.data.status)) {
          var msg =
            (result.data && (result.data.description || result.data.message)) ||
            'Could not add to cart. Check your Kaching plan selection and try again.';
          console.error('[dcoded-llp] cart add error', result.data);
          showOfferError(msg);
          resetStickyCtas();
          return false;
        }
        // Re-enable before leaving so browser back / bfcache doesn't restore a dead button.
        resetStickyCtas();
        window.location.href = checkoutUrl();
        return true;
      })
      .catch(function (err) {
        console.error('[dcoded-llp] cart add failed', err);
        showOfferError('Could not add to cart. Please try again.');
        resetStickyCtas();
        return false;
      });
  }

  function initSticky(root) {
    if (!root || !markInited(root)) return;

    var lifestyle = document.querySelector('[data-dcoded-llp-lifestyle]');
    var cta = root.querySelector('[data-dcoded-llp-sticky-cta]');
    resetStickyCtas();

    function syncHeaderWithSticky(showSticky) {
      document.querySelectorAll('[data-dcoded-llp-header-bar]').forEach(function (bar) {
        bar.classList.toggle('is-away', !!showSticky);
      });
    }

    function onScroll() {
      var show;
      if (!lifestyle) {
        show = true;
      } else {
        show = lifestyle.getBoundingClientRect().bottom <= window.innerHeight;
      }
      root.classList.toggle('is-visible', show);
      // Header stays sticky until bottom ATC comes into view, then slides away.
      syncHeaderWithSticky(show);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();

    function onPurchase(e) {
      updateStickyUI(root, e.detail);
    }
    document.addEventListener(PURCHASE_EVENT, onPurchase);

    root._dcodedLlpCleanup = function () {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      document.removeEventListener(PURCHASE_EVENT, onPurchase);
      syncHeaderWithSticky(false);
      inited.delete(root);
    };

    if (cta) {
      cta.addEventListener('click', function (e) {
        e.preventDefault();
        if (cta.classList.contains('is-loading')) return;
        addOfferToCart(cta);
      });
    }

    var purchase = document.querySelector('[data-dcoded-llp-purchase]');
    if (purchase) {
      updateStickyUI(root, {
        pouchPrice: purchase.getAttribute('data-pouch-price'),
        stickyNote: purchase.getAttribute('data-sticky-note'),
        stickyCta: purchase.getAttribute('data-sticky-cta'),
        reassure: purchase.getAttribute('data-reassure'),
      });
    }
  }

  /* ---------- Boot ---------- */
  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-dcoded-llp-reviews]').forEach(initReviews);
    root.querySelectorAll('[data-dcoded-llp-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-dcoded-llp-offer]').forEach(initOffer);
    root.querySelectorAll('[data-dcoded-llp-sticky]').forEach(initSticky);
    initBuyScrollLinks(document);
  }

  function onSectionLoad(e) {
    var el = e.target;
    if (!el || !el.querySelector) return;
    initAll(el);
  }

  function onSectionUnload(e) {
    var el = e.target;
    if (!el) return;
    var sticky = el.querySelector('[data-dcoded-llp-sticky]');
    if (sticky && typeof sticky._dcodedLlpCleanup === 'function') {
      sticky._dcodedLlpCleanup();
    }
    el.querySelectorAll('[data-dcoded-llp-reviews], [data-dcoded-llp-gallery], [data-dcoded-llp-offer], [data-dcoded-llp-sticky]').forEach(
      function (node) {
        inited.delete(node);
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Browser back from checkout often restores bfcache with the CTA still disabled.
  window.addEventListener('pageshow', function () {
    resetStickyCtas();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resetStickyCtas();
  });

  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', onSectionUnload);
  document.addEventListener('shopify:block:select', onSectionLoad);

  window.DcodedLlp = {
    initAll: initAll,
    initReviews: initReviews,
    initGallery: initGallery,
    initOffer: initOffer,
    initSticky: initSticky,
    addOfferToCart: addOfferToCart,
  };
})();
